export default "__VITE_ASSET__3EgYHpk8__"